import axios from "utils/axios";
import { routes } from "api/routes";

export const apiGetBrokerOrders = async (formData) => {
  const { data } = await axios.get(routes.getBrokerOrders, formData);
  return data;
};

export const apiGetFillQuality = async (strategy) => {
  const { data } = await axios.get(routes.getFillQuality, {
    params: strategy ? { strategy } : {},
  });
  return data;
};
